import React from 'react';
import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from './pages';
import MintPage from './pages/mintmeifyoucan';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/mintmeifyoucan" element={<MintPage/>} />
      </Routes>
    </Router>
  );
}

export default App;
